import { Linking } from 'react-native';

const debug = require('debug')('tca:playeroverlay:utils:links');

export const openLink = (link: string): void => {
  debug('Clicked: ', link);
  Linking.canOpenURL(link.toLowerCase()).then((supported) => {
    if (supported) {
      Linking.openURL(link);
    } else {
      debug('Unsupported URI: ' + link);
    }
  });
};
